var map = {
	"./banner.png": 78,
	"./bg.png": 51,
	"./company.png": 168,
	"./id.png": 169,
	"./mobile.png": 77,
	"./number.png": 170,
	"./qqzy.png": 171,
	"./school.png": 172,
	"./user.png": 173,
	"./yzm.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;